export default function FullScreenLoading() {
    return (
        <div className="fixed top-0 left-0 right-0 bottom-0 min-w-screen min-h-screen z-[100] bg-gray-700 opacity-90 flex flex-col items-center justify-center">
            <div className="w-16 h-16 rounded-full animate-spin border-4 border-blue-500 border-t-gray-200 bg-transparent shadow-md"></div>
            <h2 className="text-center text-white text-xl font-semibold">Loading...</h2>
            <p className="w-1/3 text-center text-white">This may take a few seconds, please don't close this page.</p>
        </div>
    )
}